import { Pipe, PipeTransform } from '@angular/core';
import * as toNoCase from 'to-no-case';

export const sgToNoCase: (value: string) => string = toNoCase;

/**
 * A Pipe that returns a space delimited string from a camel case string.
 * For example: given the input "johnDoe" returns "jhon Doe"
 */
@Pipe({
  name: 'sgToNoCase',
  standalone: false,
})
export class SgToNoCasePipe implements PipeTransform {
  transform(value: string): string {
    return sgToNoCase(value || '');
  }
}
